"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMultipleSelection = void 0;
var _react = require("react");
const useMultipleSelection = function () {
  let items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let selectedItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let setSelectedItems = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  let isSelectable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  const [checkboxState, setCheckboxState] = (0, _react.useState)(false);
  const handleCheckboxChange = isChecked => {
    setSelectedItems?.(isChecked ? items : []);
    setCheckboxState(isChecked);
  };
  (0, _react.useEffect)(() => {
    if (!isSelectable) {
      return;
    }
    setCheckboxState(items.length === selectedItems.length);
  }, [isSelectable, selectedItems.length]);
  return {
    isCheckboxChecked: checkboxState,
    onCheckboxChange: handleCheckboxChange
  };
};
exports.useMultipleSelection = useMultipleSelection;
//# sourceMappingURL=useMultipleSelection.js.map